













import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import TaskManager, { MouseMoveParam } from "@/app/core/task/TaskManager";

@Component
export default class Divider extends Vue {
  @Prop({ type: Number, required: true })
  private index!: number;

  @Prop({ type: Boolean, required: false, default: false })
  private disabled!: boolean;

  @Emit("hover")
  hoverDev(index: number): void {}

  @Emit("doubleClick")
  doubleClick(index: number): void {}

  @Emit("moveStart")
  moveStart(event: MouseEvent | TouchEvent, index: number) {}
}
